/* Marcel Afters, SHOPPABLE LOOK SYSTEM (16 Oct 2026): sizes per piece, one "Add the look" for the whole outfit. Adds go through window.MaXsell.addLines (assets/ma-look.js: the theme's own cart events,
   so the drawer opens and the count updates) with a plain /cart/add.js fallback. The button stays disabled until every piece has a size chosen. */
(function () {
  'use strict';
  if (window.__maLookSys) return; window.__maLookSys = 1;   // loaded by several sections: bind the document listeners once
  function lines(root) {
    var out = [], ok = true;
    [].forEach.call(root.querySelectorAll('[data-ma-ls-var]'), function (el) {
      var v = el.value; if (!v) { ok = false; return; } out.push({ id: v, quantity: 1 });
    });
    return ok ? out : null;
  }
  function sync(root) {
    var btn = root.querySelector('[data-ma-ls-add]'); if (!btn) return;
    var ok = !!lines(root); btn.disabled = !ok;
    var msg = root.querySelector('[data-ma-ls-msg]'); if (!msg) return;
    if (ok) { if (/^Choose/.test(msg.textContent)) msg.textContent = root.hasAttribute('data-ma-ls-single') ? '' : ''; return; }
    var missing = [].filter.call(root.querySelectorAll('[data-ma-ls-var]'), function (el) { return !el.value; }).length;
    if (root.hasAttribute('data-ma-ls-single')) { msg.textContent = 'Choose a size to add to bag.'; return; }
    msg.textContent = missing > 1 ? 'Choose a size for ' + missing + ' more pieces to add the look.' : 'Choose a size for 1 more piece to add the look.';
  }
  async function add(root, btn) {
    var ls = lines(root); if (!ls) return;
    var msg = root.querySelector('[data-ma-ls-msg]'); btn.disabled = true; if (msg) msg.textContent = 'Adding…';
    var res = null;
    try {
      if (window.MaXsell && window.MaXsell.addLines) res = await window.MaXsell.addLines(btn, ls);
      else {
        var r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ls.map(function (l) { return { id: Number(l.id), quantity: l.quantity }; }) }) });
        res = { ok: r.ok };
        if (r.ok) location.href = '/cart';
      }
    } catch (e) { res = { ok: false }; }
    if (msg) msg.textContent = res && res.ok ? 'Added to your bag.' : 'Could not add the look. Try again.';
    btn.disabled = false; sync(root);
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'ma_add_look', items: ls.length }); } catch (e) {}
  }
  document.addEventListener('change', function (e) { var r = e.target.closest && e.target.closest('[data-ma-ls]'); if (r && e.target.matches('[data-ma-ls-var]')) sync(r); });
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-ma-ls-add]'); if (!b) return; e.preventDefault(); add(b.closest('[data-ma-ls]'), b); });
  // 16 Oct 2026: the size already chosen in the product's own buy box fills that piece's row in the look (same variant id), so the shopper never picks it twice.
  function carry() {
    var root = document.querySelector('[data-mx-pdp]'); if (!root || root.classList.contains('is-pick')) return;
    var idIn = root.querySelector('[data-mx-id]'); if (!idIn || !idIn.value) return;
    [].forEach.call(document.querySelectorAll('[data-ma-ls-var]'), function (sel) {
      if (sel.tagName !== 'SELECT' || sel.value) return;
      var has = [].some.call(sel.options, function (o) { return o.value === String(idIn.value); });
      if (has) { sel.value = String(idIn.value); var r = sel.closest('[data-ma-ls]'); if (r) sync(r); }
    });
  }
  (function () {
    var root = document.querySelector('[data-mx-pdp]'); if (!root) return;
    try { new MutationObserver(carry).observe(root, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    root.addEventListener('change', function () { setTimeout(carry, 0); });
    carry();
  })();
  [].forEach.call(document.querySelectorAll('[data-ma-ls]'), sync);
})();
